<div class="advanced-search-container">
  <div class="advanced-search-card">
    <!-- Header -->
    <div class="search-header">
      <h3 class="search-title">
        <i class="fas fa-search-plus"></i>
        Búsqueda Avanzada
      </h3>
      <button class="close-btn" (click)="closeSearch()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Search Form -->
    <form class="search-form" (ngSubmit)="onSearch()">
      <!-- Término de búsqueda -->
      <div class="search-section">
        <label class="section-label">
          <i class="fas fa-keyboard"></i>
          Término de búsqueda
        </label>
        <input
          type="text"
          class="search-input"
          [(ngModel)]="searchFilters.query"
          name="query"
          placeholder="Ingrese palabras clave (título, descripción, autor)..."
          autocomplete="off">
      </div>

      <!-- Tipo de Contenido -->
      <div class="search-section">
        <label class="section-label">
          <i class="fas fa-layer-group"></i>
          Tipo de contenido
        </label>
        <div class="filter-group">
          <label class="checkbox-item">
            <input
              type="checkbox"
              [(ngModel)]="searchFilters.includePhotos"
              name="includePhotos">
            <span class="checkmark"></span>
            <i class="fas fa-camera"></i>
            Fotografías
          </label>
          <label class="checkbox-item">
            <input
              type="checkbox"
              [(ngModel)]="searchFilters.includeCovers"
              name="includeCovers">
            <span class="checkmark"></span>
            <i class="fas fa-newspaper"></i>
            Portadas Históricas
          </label>
        </div>
      </div>

      <!-- Categoría Principal -->
      <div class="search-section">
        <label class="section-label">
          <i class="fas fa-folder"></i>
          Categoría Principal
        </label>
        <select
          class="select-input"
          [(ngModel)]="searchFilters.categoryName"
          name="categoryName">
          <option value="">Todas las categorías</option>
          <option *ngFor="let category of mainCategories" [value]="category">
            {{ category }}
          </option>
        </select>
      </div>

      <!-- Subcategoría -->
      <div class="search-section">
        <label class="section-label">
          <i class="fas fa-tags"></i>
          Subcategoría
        </label>
        <div class="filter-group">
          <label class="checkbox-item" *ngFor="let subCategory of subCategories">
            <input
              type="radio"
              [(ngModel)]="searchFilters.subCategoryName"
              [value]="subCategory.name"
              name="subCategoryName">
            <span class="checkmark"></span>
            <i [class]="subCategory.icon"></i>
            {{ subCategory.name }}
          </label>
        </div>
      </div>

      <!-- Rango de Años con Slider -->
      <div class="search-section">
        <label class="section-label">
          <i class="fas fa-calendar-alt"></i>
          Rango de años ({{ searchFilters.yearFrom }} - {{ searchFilters.yearTo }})
        </label>
        <div class="year-range-container">
          <div class="year-range-labels">
            <span>{{ minYear }}</span>
            <span>{{ maxYear }}</span>
          </div>
          <div class="year-slider-container">
            <input
              type="range"
              class="year-slider"
              [min]="minYear"
              [max]="maxYear"
              [(ngModel)]="searchFilters.yearFrom"
              name="yearFrom"
              (input)="onYearRangeChange()"
              #yearFromSlider>
            <input
              type="range"
              class="year-slider year-slider-to"
              [min]="minYear"
              [max]="maxYear"
              [(ngModel)]="searchFilters.yearTo"
              name="yearTo"
              (input)="onYearRangeChange()"
              #yearToSlider>
          </div>
          <div class="year-inputs">
            <div class="year-input-group">
              <label>Desde:</label>
              <input
                type="number"
                class="year-input"
                [(ngModel)]="searchFilters.yearFrom"
                name="yearFromInput"
                [min]="minYear"
                [max]="maxYear">
            </div>
            <div class="year-input-group">
              <label>Hasta:</label>
              <input
                type="number"
                class="year-input"
                [(ngModel)]="searchFilters.yearTo"
                name="yearToInput"
                [min]="minYear"
                [max]="maxYear">
            </div>
          </div>
        </div>
      </div>

      <!-- Ordenamiento -->
      <div class="search-section">
        <label class="section-label">
          <i class="fas fa-sort"></i>
          Ordenar por
        </label>
        <select
          class="select-input"
          [(ngModel)]="searchFilters.sortBy"
          name="sortBy">
          <option value="title">Título (A-Z)</option>
          <option value="title_desc">Título (Z-A)</option>
          <option value="date_desc">Fecha (más reciente)</option>
          <option value="date_asc">Fecha (más antigua)</option>
          <option value="author">Autor (A-Z)</option>
          <option value="price_asc">Precio (menor a mayor)</option>
          <option value="price_desc">Precio (mayor a menor)</option>
        </select>
      </div>

      <!-- Botones de Acción -->
      <div class="action-buttons">
        <button type="button" class="btn-secondary" (click)="resetFilters()">
          <i class="fas fa-undo"></i>
          Limpiar Filtros
        </button>
        <button type="submit" class="btn-primary" [disabled]="!isValidSearch()">
          <i class="fas fa-search"></i>
          Buscar ({{ getTotalResults() }})
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Overlay -->
<div class="search-overlay" (click)="closeSearch()"></div>